import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  list: {
    maxHeight: 200,
    overflow: 'hidden',
    overflowY: 'auto',
  },
  zIndex: {
    zIndex: 999,
  },
}));
